theme.VideoslideshowSection = () => {
  const slideshowEle = document.querySelectorAll('.video-slideshow-wrapper.swiper');
  if (!slideshowEle.length) return;

  slideshowEle.forEach(current => {
    let swiperOptions = JSON.parse(current.dataset.sliderOptions);

    swiperOptions.on = {
      slideChange: function (swiper) {
        // 1️⃣ Pause all videos in all slides
        swiper.slides.forEach(slide => {
          const vids = slide.querySelectorAll('video');
          vids.forEach(v => {
            v.pause();
            v.currentTime = 0;
          });
        });

        // 2️⃣ Play video in active slide
        const activeSlide = swiper.slides[swiper.activeIndex];
        const video = activeSlide.querySelector('video');
        if (video) {
          // Stop swiper autoplay while video plays
          video.onplay = () => {
            if (swiper.autoplay) swiper.autoplay.stop();
          };

          // Start swiper autoplay when video ends
          video.onended = () => {
            if (swiper.autoplay) swiper.autoplay.start();
          };

          // Play video (autoplay may be blocked in some browsers)
          video.play().catch(() => {
            console.log("Video autoplay blocked — user interaction required");
          });
        }

        // 3️⃣ Handle animations
        const allAnimateEles = activeSlide.querySelectorAll('[mag-animation]');
        allAnimateEles.forEach(ele => ele.classList.remove('mag-animated'));
        setTimeout(() => theme.onScrollAnimation(), 250);
      }
    };

    // Initialize Swiper
    const swiper = new Swiper(current, swiperOptions);

    // 4️⃣ Pause autoplay on hover
    current.addEventListener('mouseover', () => {
      swiper.autoplay.stop();
    });
    current.addEventListener('mouseleave', () => {
      swiper.autoplay.start();
    });

    // 5️⃣ Shopify design mode logic
    if (Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        const targetEle = e.target;
        if (!targetEle.dataset?.swiperSlideIndex) return;

        const sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
        swiper.slideTo(sliderIndex);
        swiper.autoplay.stop();
      });

      const customizationEvents = [
        'shopify:inspector:activate', 'shopify:inspector:deactivate',
        'shopify:section:load', 'shopify:block:deselect', 'shopify:section:reorder',
        'shopify:section:select', 'shopify:section:deselect'
      ];
      customizationEvents.forEach(event => {
        document.addEventListener(event, () => swiper.init(swiperOptions));
      });
    }

    // 6️⃣ Play the first slide video on load
    const firstVideo = current.querySelector('.swiper-slide-active video');
    if (firstVideo) {
      firstVideo.play().catch(() => {
        console.log("First video autoplay blocked — user interaction required");
      });
    }
  });
};

// On-scroll animation (unchanged)
theme.onScrollAnimation = () => {
  const animationEle = document.querySelectorAll('[mag-animation]');
  const animationObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let animationDelay = entry.target.dataset?.magDelay;
        if (animationDelay) {
          setTimeout(() => entry.target.classList.add('mag-animated'), parseInt(animationDelay));
        } else {
          entry.target.classList.add('mag-animated');
        }
      }
    });
  }, { threshold: [0.25] });

  animationEle.forEach(ele => animationObserver.observe(ele));
};

// Initialize
window.addEventListener('DOMContentLoaded', () => {
  theme.VideoslideshowSection();
});
